import React, { useEffect } from 'react';
import logoHandBtn from '../assets/logo_hand_button.png';

const PublicHomePage: React.FC = () => {
  useEffect(() => {
    document.title = 'Praxys.ai — makes better';
  }, []);

  return (
    <main className="praxys-public-home">
      <nav className="praxys-public-nav" aria-label="Public navigation">
        <a href="/" className="praxys-public-brand">
          <img src={logoHandBtn} alt="Praxys.ai" />
          <span>Praxys.ai</span>
          <span className="praxys-public-brand-tagline">makes better</span>
        </a>
        <div className="praxys-public-nav-links">
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
          <a href="/login" className="praxys-public-login-link">Login</a>
        </div>
      </nav>

      <section className="praxys-public-hero">
        <div className="praxys-public-hero-copy">
          <p className="praxys-public-eyebrow">Praxys.ai — makes better</p>
          <h1>Praxys.ai helps you build agents, automate work, and chat with your data.</h1>
          <p>
            Praxys.ai is an AI-powered agent automation platform for everyday users, creators,
            operators, and businesses. Use it like a smarter workspace where you can create intelligent
            workflows, connect approved tools, build knowledge bases, schedule actions, and ask questions
            across documents, datasets, and content you provide.
          </p>
          <div className="praxys-public-actions">
            <a href="/login" className="praxys-public-primary-btn">Sign in to Praxys.ai</a>
            <a href="/privacy" className="praxys-public-secondary-link">Review privacy policy</a>
          </div>
        </div>

        <div className="praxys-public-panel" aria-label="Praxys.ai capabilities">
          <div>
            <span>Agents</span>
            <strong>Create task, knowledge, workflow, and API agents for personal or business automation.</strong>
          </div>
          <div>
            <span>Knowledge</span>
            <strong>Build knowledge bases from documents, datasets, and other content.</strong>
          </div>
          <div>
            <span>Connectors</span>
            <strong>Authorize services such as calendar, email, storage, and business systems.</strong>
          </div>
        </div>
      </section>

      <section className="praxys-public-section">
        <h2>What Praxys.ai does</h2>
        <div className="praxys-public-grid">
          <article>
            <h3>Agent automation</h3>
            <p>
              Create and run AI-powered workflows that can plan, execute, and organize work across
              connected services using the tools and permissions you approve.
            </p>
          </article>
          <article>
            <h3>Knowledge bases</h3>
            <p>
              Create simple or complex knowledge bases from documents, datasets, websites, and content
              so Praxys.ai can work with reusable context.
            </p>
          </article>
          <article>
            <h3>Chat with data</h3>
            <p>
              Ask questions against uploaded files, structured datasets, and knowledge bases with
              grounded responses based on the content available to you.
            </p>
          </article>
          <article>
            <h3>Tool connectors</h3>
            <p>
              Connect approved services such as calendar, email, storage, and business systems so agents
              can support scheduling, notifications, document handling, and workflow execution.
            </p>
          </article>
        </div>
      </section>

      <footer className="praxys-public-footer">
        <a href="/privacy">Privacy Policy</a>
        <a href="/terms">Terms of Service</a>
        <a href="/login">Login</a>
        <span>©2026 Felfi</span>
      </footer>
    </main>
  );
};

export default PublicHomePage;
